import {TagCategoryEntity,} from "@ots-frontend/ots-data";
import {useCallback} from "react";
import {useNavigate} from "react-router-dom";
import {TagCategoryAction} from "./TagCategoryActionMenu";
import {useTagCategoryMutation} from "../../../hooks/useTagCategoryMutation";

export type UseTagCategoryActionProps = {}

export type UseTagCategoryActionResult = {
  onTagCategoryActionClick: (tagCategory: TagCategoryEntity, action: TagCategoryAction) => void;
}

export const useTagCategoryAction = (props: UseTagCategoryActionProps = {}): UseTagCategoryActionResult => {
  const {} = props

  const navigate = useNavigate();

  const {
    deleteTagCategory,
  } = useTagCategoryMutation()

  const _onTagCategoryActionClick = useCallback((tagCategory: TagCategoryEntity, action: TagCategoryAction) => {
    if (action === "EDIT") {
      navigate(`/tags/categories/form`, {state: {id: tagCategory.id}})
    } else if (action === "DELETE") {
      deleteTagCategory(tagCategory.id, undefined)
    }
  }, [navigate, deleteTagCategory])

  return {
    onTagCategoryActionClick: _onTagCategoryActionClick
  }
}
